// =============================================================================
// web/shims/react-native-apple-authentication.js — WEB shim.
//
// "Sign in with Apple" via the native invertase module is iOS-only. On web,
// services/apple-auth.ts checks Platform.OS !== 'ios' → the Apple button never
// renders, so this shim only needs to keep the bundle building. `isSupported` is
// false and the button component is null. Native iOS resolves the real package.
// =============================================================================
export const appleAuth = {
  isSupported: false,
  async performRequest() {
    throw new Error('Sign in with Apple is not available on the web build of CRYB.');
  },
  Operation: { IMPLICIT: 0, LOGIN: 1, REFRESH: 2, LOGOUT: 3 },
  Scope: { EMAIL: 0, FULL_NAME: 1 },
};

export const AppleButton = null;

export default appleAuth;
